import {APP_INITIALIZER, NgModule} from '@angular/core';
// Imports third-party shared modules (angular, angular materials, covalent,..)

// App Services
import {UserinfoService} from "./components/index/service/userinfo.service";
import { CiamService } from './services/ciam.service';


@NgModule({
  imports: [
  ],
  declarations: [
  ],
  providers: [
    UserinfoService,
    {
      provide: APP_INITIALIZER,
      useFactory: (ciam: CiamService) =>
        () => ciam.ensureToken().catch(e => console.warn('[InitModule] ensureToken failed', e)),
      deps: [CiamService],
      multi: true
    },
  ],


})
export class InitModule {

}
